import { FC, Fragment } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
// Types
import UserRoles from 'app/types/UserRoles';
// Models
import { IMyUser } from 'app/models/User';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectMyUser } from 'app/store/Users/Users.selectors';
// Mui
import { Divider, ListItemButton, ListItemText } from '@mui/material';

type Props = {
  onClose: () => void;
};

const PresenterMenuItems:FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();
  // State
  const myUser:IMyUser | null = useAppSelector(selectMyUser);

  const listItems = [
    { to: '/presenter/cases', type: 'item', label: t('components.userDrawer.cases') },
    { type: 'divider' }
  ];

  if ( !myUser || (myUser.role !== UserRoles.Presenter && myUser.role !== UserRoles.Client)) return null;
  return (
    <Fragment>
      {listItems.map((listItem:any, index:number) => {
        if ( listItem.type === 'divider' ) return (
          <Divider key={`user menu list divider ${index}`} component="li" />
        );
        return (
          <ListItemButton
            key={`user menu list item ${index}`}
            component={Link}
            to={listItem.to}
            onClick={onClose}
            sx={{ textTransform: 'capitalize' }}
          ><ListItemText primary={listItem.label} /></ListItemButton>
        );
      })}
    </Fragment>
  );
}

export default PresenterMenuItems;
